import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrelloRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 31 31",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "url(#paint0_linear_14623_798)",
		fillRule: "evenodd",
		d: "M23.4 4.8h-16a3 3 0 0 0-2.6 2.7v15.9A3 3 0 0 0 7.5 26h15.9a3 3 0 0 0 2.6-2.6v-16a3 3 0 0 0-2.6-2.6m-9.4 16a1.3 1.3 0 0 1-1.2 1.3h-4A1.3 1.3 0 0 1 7.7 21V9A1.3 1.3 0 0 1 9 7.7h3.9A1.3 1.3 0 0 1 14 8.8zm9.3-5.2a1.3 1.3 0 0 1-1.3 1.3h-4a1.3 1.3 0 0 1-1.2-1.3V8.9a1.3 1.3 0 0 1 1.3-1.3H22a1.3 1.3 0 0 1 1.3 1.2z",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_14623_798",
		x1: 15.4234,
		y1: 26.0405,
		x2: 15.4234,
		y2: 4.81538,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", {
			offset: .18,
			stopColor: "#0052CC"
		}), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#2684FF"
		})]
	}) })]
});
export default SvgTrelloRegularIcon;
